// src/pages/WritePost/index.jsx
import { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { fakeApi } from '../../api/fakeApi';

const { TextArea } = Input;

const WritePost = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 检查登录状态
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      message.warning('请先登录再写文章');
      navigate('/auth');
    }
  });

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 再次检查登录状态
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        message.warning('请先登录');
        navigate('/auth');
        return;
      }
      
      // 调用API创建文章
      const response = await fakeApi.posts.createPost({
        title: values.title,
        content: values.content,
        author: user.name,
        authorAvatar: user.name.charAt(0),
        tags: values.tags ? values.tags.split(',').map(tag => tag.trim()) : []
      });
      
      if (response.success) {
        message.success('文章发布成功！');
        form.resetFields();
        navigate('/postcard');
      } else {
        message.error(response.message || '发布失败');
      }
    } catch (error) {
      message.error('发布失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="写文章">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="title"
            label="文章标题"
            rules={[{ required: true, message: '请输入文章标题' }]}
          >
            <Input placeholder="请输入文章标题" />
          </Form.Item>

          <Form.Item
            name="content"
            label="文章内容"
            rules={[{ required: true, message: '请输入文章内容' }]}
          >
            <TextArea 
              placeholder="开始写作吧..." 
              rows={10}
              showCount
              maxLength={5000}
            />
          </Form.Item>

          <Form.Item
            name="tags"
            label="标签"
          >
            <Input placeholder="输入标签，用逗号分隔（例如：React,前端,JavaScript）" />
          </Form.Item>

          <Form.Item style={{ textAlign: 'right' }}>
            <Button 
              onClick={() => navigate('/postcard')} 
              style={{ marginRight: 8 }}
              disabled={loading}
            >
              取消
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              发布文章
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default WritePost;